module.exports = __webpack_public_path__ + "static/media/KdsLoginScreen.f5aff681.png";